import { useCurrentUserContext } from '@/modules/auth/hooks/useCurrentUserContext';
import { UserRole } from '@/types/user';
import {
  ExpandMore,
  Logout,
  ManageAccountsOutlined,
} from '@mui/icons-material';
import { Button, Link, Menu, MenuItem } from '@mui/material';
import React from 'react';
import { ImageWithFallback } from '../../ImageWithFallback';

type UserMenuProps = React.HTMLAttributes<HTMLDivElement>;

export function UserMenu(props: UserMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const {
    currentUser: { firstName = '', lastName = '' } = {},
    educationProvider,
  } = useCurrentUserContext() ?? {};
  const userName = [firstName, lastName].filter(Boolean).join(' ');
  const userContext = useCurrentUserContext();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div {...props}>
      <Button
        variant="text"
        onClick={handleClick}
        aria-controls={open ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        className="flex items-center text-text"
      >
        <ImageWithFallback
          fallbackSrc="/images/user-profile.png"
          src={educationProvider?.logoUrl}
          alt="User profile"
          className="w-10 h-10 rounded-full"
        />
        <span className="ml-2 font-medium">{userName}</span>
        <ExpandMore />
      </Button>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        className="mt-1"
        PaperProps={{
          className: 'min-w-56 shadow-user-menu',
        }}
      >
        {userContext?.currentUser.roles?.some(
          role =>
            role === UserRole.Employer || role === UserRole.EducationProvider,
        ) && (
          <Link href="/settings" className="block w-full no-underline">
            <MenuItem
              className="border-b last-of-type:border-none"
              onClick={handleClose}
              key="settings"
              href="/settings"
            >
              <ManageAccountsOutlined className="mr-2" />
              Organization settings
            </MenuItem>
          </Link>
        )}

        <Link href="/logout" className="block w-full no-underline">
          <MenuItem
            className="border-b last-of-type:border-none"
            onClick={handleClose}
            key="logout"
            href="/logout"
          >
            <Logout className="mr-2" />
            Log out
          </MenuItem>
        </Link>
      </Menu>
    </div>
  );
}
